<ctx-layout [routes]="routes">
  <router-outlet></router-outlet>
</ctx-layout>
